module.exports = __webpack_public_path__ + "static/img/changxianquan.0d4110a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/changxianquan.jpg
// module id = KLR9
// module chunks = 128